
import { defineComponent, reactive, onMounted, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { useHead } from '@vueuse/head'

import { RepositoryFactory } from '@/repositories/RepositoryFactory'
const SeasonRepository = RepositoryFactory.get('season')
const SeasonGroupingRepository = RepositoryFactory.get('seasonGrouping')
const FieldRepository = RepositoryFactory.get('field')

import BaseBreadcrumb, { Breadcrumb } from '@/components/BaseBreadcrumb.vue'

import Schedule from '@/components/seasonGame/ScheduleTable.vue'
import League from '@/components/seasonGame/LeagueTable.vue'
import Tournament from '@/components/seasonGame/TournamentTable.vue'


import { Season } from '@/types/season'
import { Custom } from '@/types/custom'
import { Group } from '@/types/group'

export default defineComponent({
  name: 'SeasonGame',
  inheritAttrs: false,
  components: {
    BaseBreadcrumb,

    Schedule,
    League,
    Tournament
  },
  setup() {
    const route = useRoute()
    const router = useRouter()

    onMounted(() => {
      getSeason()

      const mode = route.query.mode
      if (mode == null) {
        gameTab.id = 'schedule'
      } else {
        gameTab.id = mode as string
      }
    })

    watch(
      () => [route.query.custom, route.query.group],
      () => {
        if (route.name === 'seasonGame') {
          setGroups()
          if (route.query.group == null) {
            gameTab.id = 'schedule'
          }
        }
      }
    )

    watch(
      () => route.query.mode,
      (mode) => {
        if (mode == null) {
          gameTab.id = 'schedule'
        } else {
          gameTab.id = mode as string
        }
      }
    )

    const customMatchType = computed(() => {
      if (route.query.group == null) return ''

      if (groups.custom?.match_type_id === 1) {
        return 'league'
      } else if (groups.custom?.match_type_id === 2) {
        return 'tournament'
      }

      return ''
    })

    const season: {
      data?: Season
    } = reactive({
      data: undefined
    })

    const groups: {
      customList: Custom[]
      custom?: Custom
      groupList: Group[]
      group?: Group
    } = reactive({
      customList: [],
      custom: undefined,
      groupList: [],
      group: undefined
    })

    const getSeason = async () => {
      try {
        const { season_id } = route.params

        const res = await SeasonRepository.getSeason(season_id)

        if (res.status === 200) {
          const r = res.data
          const data = r.data
          season.data = data.season
          groups.customList = data.groups

          setGroups()
        }
      } catch (error) {
        //
      }
    }

    const setGroups = () => {
      const custom_id = Number(route.query.custom)
      const group_id = Number(route.query.group)

      groups.custom = groups.customList.find(custom => custom.id === custom_id)

      if (groups.custom == undefined) return

      groups.groupList = groups.custom.groups
      groups.group = groups.groupList.find(group => group.id === group_id)

      getFields()
      getGrouping()
    }

    const fields = reactive({
      list: []
    })

    const getFields = async () => {
      try {
        const dataObj = {
          field_group_id: groups.custom?.field_group_id
        }

        const res = await FieldRepository.getFields(dataObj)

        if (res.status === 200) {
          const r = res.data
          const data = r.data

          fields.list = data.fields
        }
      } catch (error) {
        //
      }
    }

    const getGrouping = async () => {
      try {
        const { season_id } = route.params

        const res = await SeasonGroupingRepository.getGroupingWhole(season_id)

        if (res.status === 200) {
          const r = res.data
          const data = r.data

          const group_id = Number(route.query.group)

          groups.groupList = data.group
          groups.group = groups.groupList.find(group => group.id === group_id)
        }
      } catch (error) {
        //
      }
    }

    const gameTab: {
      id: string | null
    } = reactive({
      id: 'schedule'
    })

    const changeGameTabPanel = (event :Event) => {
      const element = event.target as HTMLInputElement

      const tabState = element.getAttribute('aria-controls')
      gameTab.id = tabState

      const { custom, group } = route.query

      router.push({ query: { custom: custom, group: group, mode: tabState } })
    }

    onMounted(() => {
      mediaQuery.list = window.matchMedia('(max-width: 560px)')
      mediaQuery.list.addEventListener('change', setDeviceWidth)
      setDeviceWidth()
    })

    const mediaQuery: {
      list?: MediaQueryList
      isMobile: boolean
    } = reactive({
      list: undefined,
      isMobile: false
    })

    const setDeviceWidth = (): void => {
      if (mediaQuery.list?.matches) {
        mediaQuery.isMobile = true
      } else {
        mediaQuery.isMobile = false
      }
    }

    useHead({
      title: computed(() => '試合一覧 - ' + season.data?.topic_name + ' ' + season.data?.name)
    })

    const breadcrumbs = computed(() => {
      return [
        {
          type: 'link',
          link: {
            name: '大会一覧',
            path: '/'
          }
        },
        {
          type: 'link',
          size: 'large',
          link: {
            name: season.data?.topic_name,
            secondName: season.data?.name,
            path: '/event/' + route.params.topic_id + '/season/' + route.params.season_id,
          },
          setting: {
            path: '/event/' + route.params.topic_id
          }
        },
        {
          type: 'select',
          select: {
            type: 'game',
            currentId: groups.custom?.id,
            list: groups.customList
          }
        }
      ] as Breadcrumb[]
    })

    return {
      customMatchType,

      season,
      groups,
      getSeason,

      fields,
      getFields,

      getGrouping,

      gameTab,
      changeGameTabPanel,

      mediaQuery,

      breadcrumbs
    }
  }
})
